export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于我们</h2>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="max-w-3xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              911黑料网成立于2019年，是国内领先的娱乐八卦与热点爆料聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最快的黑料资讯，
              涵盖明星私生活、综艺内幕、网红翻车、影视剧组八卦等多个领域。作为911黑料吃瓜网与911吃瓜黑料网的官方入口，
              我们整合全网优质内容源，确保每一条爆料都有据可查。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台秉持「真实、快速、深度」的内容理念，拥有一支专业的编辑团队和广泛的爆料人网络。
              所有发布内容均经过多轮核实，同时严格保护爆料人的隐私安全。我们不仅是吃瓜的窗口，更是真相的守护者。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              截至目前，911黑料网已累计收录超过12,800起黑料事件，月活跃用户突破860万，日均页面浏览量超过3,000万次。
              无论是娱乐圈的劲爆大瓜，还是网红圈的热点争议，你都能在911黑料网找到第一手资讯。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}